import { ApiHttpService } from '../ApiHttpService';
import { HomeSerializer } from '../serializers/HomeSerializer';
import { Home } from '../../models/Home';

const HOME_PATH = 'home/';

class HomeController {
  static async all() {
    const response = await ApiHttpService.get(HOME_PATH);
    const deSerializedData = HomeSerializer.deSerialize(response.data);
    return new Home(deSerializedData);
  }
}

export { HomeController };



// WEBPACK FOOTER //
// ./src/networking/controllers/HomeController.js